export const ROUTE_META_DATA_UPDATED_EVENT = 'routes:routeMetaDataUpdated';
